// src/components/LoginPage.tsx
import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Alert } from '@mui/material';
import { fetchApi } from './fetchApi';

type Props = {
  onLoginSuccess?: () => void;
};

export default function LoginPage({ onLoginSuccess }: Props) {
  const [username, setUsername] = useState('');   // statt email
  const [password, setPassword] = useState('');   // statt passwort
  const [laden, setLaden] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLaden(true);

    try {
      await fetchApi('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password }),
      });

      onLoginSuccess?.();
    } catch (err: any) {
      setFehler(
        err?.message === '401'
          ? 'Login fehlgeschlagen. Bitte prüfe Zugangsdaten.'
          : (err?.message || 'Netzwerkfehler beim Login.')
      );
    } finally {
      setLaden(false);
    }
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper elevation={3} sx={{ width: '100%', maxWidth: 420, p: 3 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Login
        </Typography>

        {fehler && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {fehler}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="Benutzername"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            margin="normal"
            autoComplete="username"
          />

          <TextField
            label="Passwort"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            autoComplete="current-password"
          />

          <Button type="submit" variant="contained" fullWidth disabled={laden} sx={{ mt: 2 }}>
            {laden ? 'Bitte warten…' : 'Einloggen'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
